import React, { useEffect, useState } from "react";

interface VotesListProps {
    votes: any,
    loading: boolean
}

// address,
// voteChoice: String(voteChoice),
// decision,
// time: new Date(e.timestamp).toISOString(),
// points: String(points)

export default function VotesList({ votes, loading }: VotesListProps) {


    if (loading) return <div>Loading...</div>;

    return (
        <div className="p-6 w-full mx-auto">

            <div className="mb-6 grid gap-4 md:grid-cols-1">
                <div className="bg-gray-800 rounded-xl p-4 border border-gray-700">
                    <h3 className="text-xl text-white font-bold mb-2">Results:</h3>
                    <h5 className="text-m">Total Voters: {votes.votes.length}</h5>
                    <h5 className="text-m">Total Yes: {votes.totals.yesPoints}</h5>
                    <h5 className="text-m">Total No: {votes.totals.noPoints}</h5>
                </div>
            </div>

            <div className="mb-6 grid gap-4 md:grid-cols-1">
                <div className="bg-gray-800 rounded-xl p-4 border border-gray-700">
                    <table className="w-full text-left table-auto border-collapse">
                        <thead>
                            <tr className="border-b border-gray-700">
                                <th className="py-2 px-4">Time</th>
                                <th className="py-2 px-4">Address</th>
                                <th className="py-2 px-4">Points</th>
                                <th className="py-2 px-4">Decision</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                votes.votes.map((e) => (
                                    <tr key={e.time} className="border-b border-gray-800">
                                        <td className="py-2 px-4 text-gray-300">{e.time}</td>
                                        <td className="py-2 px-4 text-gray-300">{e.address}</td>
                                        <td className="py-2 px-4 text-gray-300">{e.points}</td>
                                        <td className="py-2 px-4 text-gray-300">{e.voteChoice == "true" ? "Yes" : "No"}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

